import { Component, Input, ChangeDetectorRef } from '@angular/core';

import { Controllers } from '@shared/core/controllers';

import { TilesComponent } from '../../tiles.shared.component';

@Component({
    selector: 'shared-tile-for-loyalty-program-product-counter',
    templateUrl: './tile-for-loyalty-program-product-counter.shared.component.html',
    styleUrls: ['./tile-for-loyalty-program-product-counter.shared.component.scss']
})
export class TileForLoyaltyProgramProductCounterComponent extends TilesComponent {
    @Input() public programItem: OLO.Ordering.ILoyaltyProgramProductItemModel;
    @Input() public pathToImages: string = '/assets/icons/';
    @Input() public size: number = 150;

    constructor(
        public changeDetectorRef: ChangeDetectorRef,
        public controllers: Controllers,
    ) {
        super(changeDetectorRef, controllers);
    }

    public get currCount(): number {
        return this.programItem?.product?.CurrentProductCount || 0;
    }

    public get maxCount(): number {
        return this.programItem?.program?.PurchaseQuantity || 0;
    }

    public get iconActive(): string {
        return this.programItem && `icon.program-${this.programItem.codeName}-full.svg` || null;
    }
}
